export const AUTH_ENDPOINTS = Object.freeze({
  LOGIN_ADMIN_EMAIL: '/v1/auth/login/admin/email',
  REFRESH_ADMIN: '/v1/auth/refresh/admin',
  REFRESH_RECRUITER: '/v1/auth/refresh/recruiter',
  ME_ADMIN: '/v1/auth/me/admin',
  LOGOUT_ADMIN: '/v1/auth/logout/admin',
});

export const ADMIN_ENDPOINTS = Object.freeze({
  BANNERS_ACTIVE: '/v1/admin/banners/active',
  BANNERS: '/v1/admin/banners',
  BANNERS_CREATE: '/v1/admin/banners/create',
  BANNER_BY_ID: (id) => `/v1/admin/banners/${id}`,
  ANALYTICS_DASHBOARD_DETAILS: '/v1/admin/analytics/dashboard-details',
  ANALYTICS_DASHBOARD_DETAILS_FOR_COLLEGE: '/v1/admin/analytics/dashboard-details-for-college',
  ANALYTICS_JOBS_LAST_12_MONTHS: '/v1/admin/analytics/jobs-last-12-months',

  JOBS: '/v1/admin/jobs',
  JOBS_ALL: '/v1/admin/jobs/all-job-posts',
  JOBS_EDIT_BY_ID: (id) => `/v1/admin/jobs/edit-job-post/${id}`,
  JOBS_DELETE_BY_ID: (id) => `/v1/admin/jobs/delete-job-post/${id}`,
  JOBS_VERIFY_BY_ID: (id) => `/v1/admin/jobs/verify-jobPost/${id}`,

  GROUPS_ALL: '/v1/admin/groups/all-groups',
  GROUPS_CREATE: '/v1/admin/groups/create-group',
  GROUPS_SEND_CREDITS: '/v1/admin/groups/send-credits',

  COUPONS_LIST: '/v1/admin/coupons/list-coupons',
  COUPONS_CREATE: '/v1/admin/coupons/create-coupon-code',
  COUPONS_UPDATE_BY_ID: (id) => `/v1/admin/coupons/update-coupon-code/${id}`,

  PAYMENTS_CREATE_PROMO: '/v1/admin/payments/create-promo-code',
  COMPANY_DASHBOARD_INFO: '/v1/admin/company-dashboard/companies-info',

  /** Company module (v1/admin/company) */
  COMPANY_GET_ALL: '/v1/admin/company/get-all-companies',
  COMPANY_GET_BY_ID: (id) => `/v1/admin/company/get-company/${id}`,
  COMPANY_CREATE: '/v1/admin/company/create-company',
  COMPANY_UPDATE_BY_ID: (id) => `/v1/admin/company/update-company/${id}`,
  COMPANY_DELETE_BY_ID: (id) => `/v1/admin/company/delete-company/${id}`,

  /** Users module (v1/admin/users) */
  USERS_ALL: '/v1/admin/users/all-users',
  USERS_USER_WITH_ID: (id) => `/v1/admin/users/user-with-id/${id}`,
  USERS_REGISTER_WITH_EMAIL: '/v1/admin/users/register-with-email',

  CREDITS_SEND_TO_CLUSTER: '/v1/admin/credits/send-to-cluster',
  CREDITS_SEND_TO_USER: '/v1/admin/credits/send-to-user',

  USERS_DELETE_BY_ID: (userId) => `/v1/admin/users/delete/${userId}`,

  /** Cluster module (v1/admin/cluster) */
  CLUSTER_ALL: '/v1/admin/cluster/all-clusters',
  CLUSTER_BY_ID: (id) => `/v1/admin/cluster/clusters/${id}`,
  CLUSTER_CREATE: '/v1/admin/cluster/clusters',

  /** Blogs module (v1/admin/blogs) */
  BLOGS_GET_ALL: '/v1/admin/blogs/get-all-blogs',
  BLOGS_GET_BY_ID: (id) => `/v1/admin/blogs/get-blog/${id}`,
  BLOGS_CREATE: '/v1/admin/blogs/create-blog',
  BLOGS_EDIT_BY_ID: (id) => `/v1/admin/blogs/edit-blog/${id}`,
  BLOGS_DELETE_BY_ID: (id) => `/v1/admin/blogs/delete-blog/${id}`,

  /** Colleges (v1/admin/colleges) */
  COLLEGES_GET_ALL: '/v1/admin/colleges/get-all-colleges',
  COLLEGES_GET_BY_ID: (id) => `/v1/admin/colleges/get-college/${id}`,
  COLLEGES_CREATE: '/v1/admin/colleges/create-college',
  COLLEGES_UPDATE_BY_ID: (id) => `/v1/admin/colleges/update-college/${id}`,
  COLLEGES_DELETE_BY_ID: (id) => `/v1/admin/colleges/delete-college/${id}`,
  COLLEGES_SEARCH: '/v1/admin/colleges/college-search',
  COLLEGES_TOGGLE_DRIVE: (id) => `/v1/admin/colleges/toggle-drive/${id}`,

  /** Suggestions / feedback (v1/admin/suggestions) */
  SUGGESTIONS_GET_ALL: '/v1/admin/suggestions/get-all-suggestions',
  SUGGESTIONS_GET_BY_ID: (id) => `/v1/admin/suggestions/get-suggestion/${id}`,
  SUGGESTIONS_UPDATE_BY_ID: (id) => `/v1/admin/suggestions/update-suggestion/${id}`,
  SUGGESTIONS_DELETE_BY_ID: (id) => `/v1/admin/suggestions/delete-suggestion/${id}`,

  /** Interviews (v1/admin/interviews) */
  INTERVIEWS_ALL: '/v1/admin/interviews/all-interviews',
  INTERVIEWS_USER: (id) => `/v1/admin/interviews/user-interviews/${id}`,

  /** Alerts (v1/admin/alerts) */
  ALERTS_SEND_BY_JOB_POST: (jobPostId) => `/v1/admin/alerts/send-alert-by-job-post/${jobPostId}`,
  ALERTS_HISTORY: '/v1/admin/alerts/history',
  ALERTS_STATS: '/v1/admin/alerts/stats',

  ADMINS: '/v1/admin/admins',
  ADMIN_BY_ID: (id) => `/v1/admin/admins/${id}`,
  ADMIN_SUPER_BY_ID: (id) => `/v1/admin/admins/super-admin/${id}`,
  ADMINS_CLUSTER: '/v1/admin/admins/cluster-admins',
  ADMINS_FORGOT_PASSWORD: '/v1/admin/admins/forgot-password',
  ADMINS_RESET_PASSWORD: (token) => `/v1/admin/admins/reset-password/${token}`,
});
